import s from "./Several.module.css";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Grid, Tab, Tabs } from "@mui/material";
import TaskIcon from "@mui/icons-material/Task";
import { useTranslation } from "react-i18next";
import { updateLocation } from "../../../store/slices/localSlice";
import { TAB_CONFIG } from "./Config/tabConfig";
import ConfigsSearcher from "../../../config/Configs";
import MaxDiarioTab from "./Tabs/TabMaxAmount";
import MinimumSaleTab from "./Tabs/TabMinimumSale";

// Tab Component Registry
const TAB_COMPONENTS = {
  MaxDiarioTab,
  MinimumSaleTab,
};

const Several = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const uiConfig = useSelector((state) => state.local.uiConfig);
  const agencySelected = useSelector((state) => state.myAgencies?.selected_agencie_to_consult);
  
  const [activeTab, setActiveTab] = useState(TAB_CONFIG.MAX_DIARIO_TJ.id);

  useEffect(() => {
    dispatch(updateLocation({ agencias: true }));
  }, [dispatch]);

  const { isFeatureEnabled, configFinder } = ConfigsSearcher();
  const appConfigDebug = useSelector((state) => state.gamma?.appConfig);

  // filtro tabs: permiso por agencyLevel + (si la tab tiene featureKey) flag por organizacion
  const availableTabs = Object.values(TAB_CONFIG).filter(tab =>
    tab.permissions.includes(agencySelected?.agencyLevel) &&
    (!tab.featureKey || isFeatureEnabled(tab.featureKey))
  );

  // DEBUG temporal: diagnostico visibilidad pestania "Maximo diario tj"
  console.log("[DEBUG Varios]", {
    agencyLevel: agencySelected?.agencyLevel,
    permisoConcentrator: TAB_CONFIG.MAX_DIARIO_TJ.permissions.includes(
      agencySelected?.agencyLevel,
    ),
    maxDiario_raw: configFinder("MENU_MAX_DIARIO_TJ_ENABLED"),
    maxDiario_enabled: isFeatureEnabled("MENU_MAX_DIARIO_TJ_ENABLED"),
    availableTabs: availableTabs.map((t) => t.id),
    appConfig: appConfigDebug,
  });

  useEffect(() => {
    const stillVisible = availableTabs.some((tab) => tab.id === activeTab);
    if (!stillVisible && availableTabs.length > 0) {
      setActiveTab(availableTabs[0].id);
    }
  }, [availableTabs, activeTab]);

  // Obtiene componente activo basado en el activeTab
  const ActiveTabComponent = TAB_COMPONENTS[
    TAB_CONFIG[Object.keys(TAB_CONFIG).find(key => TAB_CONFIG[key].id === activeTab)]?.component
  ];

  return (
    <Grid container className={s.container} sx={{ background: uiConfig.primary.ligth }}>
      <Grid item container xs={11} className={s.header}>
        <Grid item 
          xs={12} 
          md={activeTab.includes( 'listado-minimo-venta') ? 6 : 12} 
          lg={activeTab.includes('listado-minimo-venta') ? 6 : 12} 
          className={s.titleContainer}
        >
          <TaskIcon sx={{ fontSize: "1.8rem", color: "primary.light" }} />
          {/* <h4>{t("Solicitudes")}</h4> */}
          <h4>{(TAB_CONFIG[Object.keys(TAB_CONFIG).find(key => TAB_CONFIG[key].id === activeTab)]?.title)}</h4>
        </Grid>
      </Grid>

      <Grid item xs={12} className={s.content}>
        <Grid item xs={12} className={s.tabContainer}>
          <Tabs
            value={activeTab}
            onChange={(e, value) => {setActiveTab(value)}}
            textColor="secondary"
            indicatorColor="secondary"
            className={s.tabs}
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
          >
            {availableTabs.map((tab) => (
              <Tab
                key={tab.id}
                value={tab.id}
                label={t(tab.label)}
                className={`${s.tabItem} ${activeTab === tab.id && s.selected}`}
              />
            ))}
          </Tabs>
        </Grid>

        <Grid item xs={12} md={12} className={s.render}>
          {ActiveTabComponent && <ActiveTabComponent />}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Several;